import "./styles.scss";
import React from "react";

export const Footer: React.FC = () => {
  return (
    <footer className="footer">
      <p>SORDO MADALENO</p>
      <p>IT | SOFTWARE DEVELOPMENT</p>
    </footer>
  );
};
